import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'
import edtech from '../assets/png/edtech.png'
import npm from '../assets/png/npm.png'
import social from '../assets/png/social.png'
import demo1 from '../assets/pdf/EdTechPlatform.pdf'
import demo2 from '../assets/pdf/socialmediaPlatform.pdf'
export const projectsData = [
    {
        id: 1,
        projectName: 'CourseBay',
        projectDesc: 'An EdTech Platform where instructors can create courses and users can purchase those courses. Features complete routes and data protection using JWT and CSRF , scalable image and data storage using AWS S3, email OTP services with AWS SES and real time payments with Razorpay Payment APIs ',
        tags: ['MERN stack', 'Next.js', 'Razorpay Payment APIs', 'Ant Design'],
        code: 'https://github.com/GauravBansal29/EduTechProject-frontend',
        demo: demo1,
        image: edtech
    },
    {
        id: 2,
        projectName: 'Socially',
        projectDesc: 'Developed a social media platform where people can share their views with likeminded people using posts and can chat with them. Users can follow, unfollow, search friends, like, comment on posts, get real time notifications about posts, do real time chating',
        tags: ['MERN stack', 'Socket.io'],
        code: 'https://github.com/GauravBansal29/socially',
        demo: demo2,
        image: social
    },
    {
        id: 3,
        projectName: 'mern_pay',
        projectDesc: 'Developed a npm package to facilitate MERN developers to integrate payments in their applications using predefined functions in the package. The package has 600+ downloads till now.',
        tags: ['Node.js', 'Rest APIs', 'Axios'],
        code: 'https://github.com/GauravBansal29/mern_payment-npm-package',
        demo: 'https://www.npmjs.com/package/mern_pay',
        image: npm
    },
    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/